module.exports = __webpack_public_path__ + "8ccfaa98024754e4c7dff2d3095747c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/1.00ct.png
// module id = 809
// module chunks = 0